import {
	saveSupplierApproveService,
	recallSupplierServices,
	updateApproveProcessStatusService,
} from "@/services/approveServices";
import { Message } from "element-ui";
import Vue from "vue";
export async function saveApproveFun(params) {
	try {
		let res = await saveSupplierApproveService(params);
		return res;
	} catch (err) {
		console.log(err);
		Message.error("保存审批流失败");
		// return err
	}
}

export async function updateApproveFun(params) {
	try {
		let res = await updateApproveProcessStatusService(params);
		return res;
	} catch (err) {
		console.log(err);
		Message.error("提交审批流失败");
		// return err
	}
}

export async function recallApproveItemFun(params) {
	try {
		let res = await recallSupplierServices(params);
		if (res.code == 10000000) {
			return res;
		} else if (res.code > 10000000) {
			Message.warning(res.msg);
			// Alert(res.msg, "提示", {
			//   confirmButtonText: "确定",
			// });
		} else {
			Message.error("系统异常");
		}
	} catch (error) {
		Message.error("网络请求失败");
	}
}

/**
 *  工作台通过type获取跳转路由
 */
export function getRouteIdByType(type) {
	let routeId = "";
	switch (type) {
		case "SUPPLIER": //供应商
			routeId = "supplierBApprove";
			break;
		case "PROJECT_FRONT": //事前成本
			routeId = "beforInfoDetails";
			break;
		case "PROJECT_MIDDLE": //事中成本
			routeId = "inTheInfoDetails";
			break;
		case "GENERAL_CONTRACT": //总包合同
			routeId = "relationWorkList";
			break;
		case "PROJECT": //项目
			routeId = "addHouseDelive";
			break;
		case "SUB_CONTRACT": //分项合同
			routeId = "totalApproveList";
			break;
		case "DECLARATION": //会议提报
			routeId = "meetingBillDetailView";
			break;
		case "INPUT_BILL_APPROVE": //进项发票报销审批 ====
			routeId = "approveDetails";
			break;
		case "OUTPUT_BILL_APPROVE": //销项发票报销审批 ====
			routeId = "salesInvoiceDetail";
			break;
		case "EARNING_COST": //收入成本
			routeId = "incomingConstDetail";
			break;
		case "OFFICIAL_DOCUMENT_INTERNAL_GENERAL_OFFICE": //公文-内部文件(综合办)
			routeId = "generalOfficeDetails";
			break;
		case "OFFICIAL_DOCUMENT_INTERNAL": //公文-内部文件(其他)
			routeId = "generalOfficeDetails";
			break;
		// case "OFFICIAL_DOCUMENT_INTERNAL": //公文-内部
		// 	routeId = "generalOfficeDetails";
		// 	break;
		case "OFFICIAL_DOCUMENT_EXTERNAL": //公文-外部
			routeId = "incomingManageDetails";
			break;
		case "SPORADIC_PROJECT": //零星工程
			routeId = "sporadicDetail";
			break;
		case "BID_PLAN": //采购计划
			routeId = "bidPlanDetail";
			break;
		case "BID_PRICE_CONTROLE": //控制价审核
			routeId = "controlPriceDetail";
			break;
		case "BID_FILE": //采购文件审核
			routeId = "bidFileDetail";
			break;
		case "BID_JOIN_SIGNATURE": //采购联签单
			routeId = "bidOrderDetail";
			break;
		case "BID_JOIN_LEDGER": //采购台账
			routeId = "bidLedgerDetail";
			break;

	}
	return routeId;
}

/**
 *  工作台通过type获取跳转列表路由
 */
export function getListRouteIdByType(type, subtype) {
	let routeId = "";
	switch (type) {
		case "SUPPLIER": //供应商
			routeId = "supplierBSelfMag";
			break;
		case "PROJECT_FRONT": //事前成本
			routeId = "beforIndex";
			break;
		case "PROJECT_MIDDLE": //事中成本
			routeId = "inTheIndex";
			break;
		case "GENERAL_CONTRACT": //总包合同
			routeId = "payment-cycle";
			break;
		case "PROJECT": //项目
			routeId = "payment-parkfeeRelation";
			break;
		case "SUB_CONTRACT": //分项合同 payment-orderCheck劳务 buyContract材料 machineryContractMag机械 otherContract其它
			if (subtype.includes('劳务')) {
				routeId = "payment-orderCheck";
			} else if (subtype.includes('材料')) {
				routeId = "buyContract";
			} else if (subtype.includes('机械')) {
				routeId = "machineryContractMag";
			} else if (subtype.includes('其它')) {
				routeId = "otherContract";
			}
			break;
		case "DECLARATION": //会议提报
			routeId = "meetingList";
			break;
		case "INPUT_BILL_APPROVE": //进项发票报销 ====
			routeId = "incomeInvoice";
			break;
		case "OUTPUT_BILL_APPROVE": //销项发票报销 ====
			routeId = "salesInvoice";
			break;
		case "EARNING_COST": //收入成本
			routeId = "incomeConstList";
			break;
		case "OFFICIAL_DOCUMENT_SEND": //公文-发文
			routeId = "documentManage";
			break;
		case "OFFICIAL_DOCUMENT_RECEIVE": //公文-收文
			routeId = "incomingManage";
			break;
		case "SPORADIC_PROJECT": //零星工程
			routeId = "sporadicIndex";
			break;
		case "BID_PLAN": //采购计划
			routeId = "bidPlan";
			break;
		case "BID_PRICE_CONTROLE": //控制价审核
			routeId = "controlPrice";
			break;
		case "BID_FILE": //采购文件审核
			routeId = "bidFile";
			break;
		case "BID_JOIN_SIGNATURE": //采购联签单
			routeId = "bidOrder";
			break;
		case "BID_JOIN_LEDGER": //采购台账
			routeId = "bidLedger";
			break;
	}
	return routeId;
}

//返回待审批页面 from:需要关闭的tab页
export function goBackApprove(approveFlag, from, to) {
	Vue.prototype.bus.$emit("tabClose", from);
	if (approveFlag === "historyApproveDetail") {
		Vue.prototype.bus.$emit("navMenuChange", {
			routeId: "approvalHistory",
		});
	} else if (approveFlag.includes("commonMessage")) {  //从消息中心跳转
		Vue.prototype.bus.$emit("navMenuChange", {
			routeId: "latestNews",
		});
	} else if (approveFlag === "documentMessage") {
		Vue.prototype.bus.$emit("navMenuChange", {
			routeId: "documentMessage",
		});
	} else if (approveFlag === "currentApprove") {
		Vue.prototype.bus.$emit("navMenuChange", {
			routeId: "pendingApproval",
		});
	}

}

